import { mapState, mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash';
import contractsHistory from '@/components/contracts-history/contracts-history.vue';
import exportHistory from '@/components/export-history/export-history.vue';
import historyFilters from '@/components/account/history/trades/history-filters/history-filters.vue';
import contentLoaderMixin from '@/mixins/contentLoader';
import { isMarketSingle } from '@/utils/helpers';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [
    contentLoaderMixin,
    loaderMixin,
  ],
  props: {
    showExport: Boolean,
  },
  components: {
    contractsHistory,
    exportHistory,
    historyFilters,
  },
  data() {
    return {
      activeFilter: null,
      marketId: undefined,
      recent: true,
      isOpen: false,
      loading: null,
      ready: false,
    };
  },
  created() {
    this.debouncedDoLoading = debounce(this.doLoading, 300);
  },
  watch: {
    activeFilter(val) {
      if (val) {
        this.debouncedDoLoading(val.marketId);
      }
    },
    $route: {
      handler: 'routeHandler',
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapState('market', ['market']),
    ...mapState('profile', [
      'tradeHistory',
      'marketHistory',
      'tradedMarkets',
    ]),
    showMessage() {
      return !this.isLoading &&
        this.$route.params.marketId &&
        this.$route.params.marketId !== 'all' &&
        this.market.marketId &&
        !isMarketSingle(this.market);
    },
    filteredContracts() {
      if (this.activeFilter) {
        // to not show old data while loading new
        return (this.activeFilter.marketId !== this.marketHistory.marketId) ?
          [] : this.marketHistory.data;
      }
      // whole trade history
      return this.tradeHistory.data;
    },
    canLoadMore() {
      return this.activeFilter ? this.marketHistory.canLoadMore : this.tradeHistory.canLoadMore;
    },
    showMarketNames() {
      return this.activeFilter === null;
    },
    isExportAvailable() {
      return this.showExport;
        // this.tradeHistory &&
        // this.tradeHistory.data &&
        // this.tradeHistory.data.length > 0;
    },
  },
  methods: {
    ...mapActions('profile', ['getTradeHistory', 'getTradedMarkets']),
    ...mapActions('market', ['getMarket', 'clearMarket']),
    routeHandler(route) {
      const marketId = route.params.marketId;
      const isAll = marketId === 'all';
      const isEmpty = !marketId;
      this.loaderAdd(document.body);

      if (marketId && !isAll) {
        this.marketId = Number(marketId);
      } else if (isAll) {
        this.marketId = 'all';
      } else {
        this.marketId = undefined;
      }

      this.getTradedMarkets({ cache: true })
        .then((val) => {
          if (this.marketId) {
            const marketFilter = val.find(o => o.marketId === this.marketId);
            if (marketFilter) {
              this.activeFilter = { ...marketFilter };
            }
          }
        })
        .then(() => {
          if (marketId && !isAll) {
            this.clearMarket();
            return this.getMarket({ marketId: this.marketId });
          } else if (isAll) {
            this.clearMarket();
            return this.getTradeHistory();
          }
          return Promise.resolve({});
        })
        .then(() => {
          this.loaderRemove(document.body);
          this.isOpen = isAll;
          this.recent = isEmpty;
          if (isEmpty || isAll) {
            this.activeFilter = null;
          }
          this.ready = true;
        });
    },
    loadHistory() {
      if (this.activeFilter) {
        if (this.loading !== this.activeFilter.marketId) {
          this.debouncedDoLoading(this.activeFilter.marketId);
        }
      } else if (this.canLoadMore) {
        if (this.isLayoutMobile) {
          this.loaderAdd(document.body);
        }
        this.getTradeHistory()
          .then(() => {
            if (this.isLayoutMobile) {
              this.loaderRemove(document.body);
            }
          }).catch(() => {
            if (this.isLayoutMobile) {
              this.loaderRemove(document.body);
            }
          });
      }
    },
    modalExport() {
      this.$emit('export', 'trades');
    },
    doLoading(marketId) {
      if (this.loading !== marketId) {
        this.loading = marketId;
        const contractId = (this.$route.query || {}).contractId;
        const payload = { marketId };
        if (contractId) {
          payload.contractId = contractId;
        }
        if (this.isLayoutMobile) {
          this.loaderAdd(document.body);
        }
        return this.getTradeHistory(payload)
        .then(() => {
          this.loading = null;
            if (this.isLayoutMobile) {
              this.loaderRemove(document.body);
            }
          }).catch(() => {
            if (this.isLayoutMobile) {
              this.loaderRemove(document.body);
            }
          });
      }
      return Promise.resolve({});
    },
  },
  beforeDestroy() {
    this.clearMarket();
    if (this.debouncedDoLoading) {
      this.debouncedDoLoading.cancel();
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/account/history/trades/trades.js